const htmlBody = document.querySelector('#filmConsider_card').querySelector('div[name=rejBody]');
// import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';
 // anotherFilmsPanelMarkup
import anotherFilmsPanelMarkup from '../markup2/anotherFilmsPanel.js';
export default {

  cleanContainer() {
    htmlBody.innerHTML = '';
  },

  getElement(item, index, currentFilmID) {
    // console.log(item); 
    let urlImg = '';
    if(item.image)
      urlImg = `${window.appSettings.xhrSettings.urlContentYCloud}creators/${item.image}.jpg`;
    else
      urlImg = '';

    let filmographyHTML = 'Фильмография не заполнена.';
    if(item.filmography)
      filmographyHTML = this.ifnull(item.filmography);


  return `<div class = "mainRejCard row p-0 " pID=${index} name="creator-${item.cid}"> 
              <div class = "column m-0 w-30 p-10"  name="creator-${index}-img">
                <img src="${urlImg}"  name="creator-${item.cid}-img" class="shimmer">
              </div>
              <div class = "column m-0 p-10 w-70"   name="creator-${item.cid}-name">
                <div class="row m-0 w-100 p-1"   >
                  <b class="column m-0 p-1" name="creator-${item.cid}-surname"> ${this.ifnull(item.nameF)}   </b>
                  <b class="column m-0 p-1" name="creator-${item.cid}-name">${this.ifnull(item.nameI)}   </b>
                  <b class="column m-0 p-1" name="creator-${item.cid}-patronymic">${this.ifnull(item.nameO)}  </b>
                </div>
                <div class="row m-0 p-1"  name="creator-${item.cid}-bio">
                  <p name="creator-${item.cid}-bio">${this.ifnull(item.bio)}</p>
                </div>
                <div class="row m-0 p-0">
                  <div class="filmography row" name="creator-${item.cid}-filmography">
                    <div class="column w-20">
                      <div class="imgCamera"> </div>
                    </div>
                    <p name="creator-${item.cid}-filmography" class="  w-80"> ${filmographyHTML}</p>
                  </div>
                </div>

               
                <div class="row m-0 mt-1 p-0">
                  <div class=" m-0 p-1 bYear" name="creator-${item.cid}-year"  block="bYear">
                    ${this.ifnull(item.bYear)} 
                  </div>
                  <div class=" m-0 p-1 ml-3 bPlace" name="creator-${item.cid}-birthPlace" block="bPlace">
                  ${this.ifnull(item.bPlace)}
                  </div>
                </div>
                <div class="row m-0 p-0">
                  <div class=" m-1 p-1 " name="creator-${item.cid}-mail">
                    ${this.ifnull(item.mail)}
                  </div>
                  <div class=" m-1 p-1 ml-3" name="creator-${item.cid}-phone">
                    ${this.ifnull(item.phone)}
                  </div>
                </div>
                <div class="row m-0 p-0">
                  <div class=" m-1 p-1 " name="creator-${item.cid}-sorkPlace">
                    ${this.ifnull(item.wPlace)}
                  </div>
                  <div class=" m-1 p-1 ml-3" name="creator-${item.cid}-site">
                    <a href="${this.ifnull(item.site)}" target="_blank" name="creator-${item.cid}-site">${this.ifnull(item.site)} </a>
                  </div>
                </div>
                <div class="row m-0 p-0">${anotherFilmsPanelMarkup.drawDataInDiv(item.rejFilms, currentFilmID)}</div>
              </div>
          </div>`;
  },

  ifnull (someData) {
    return (someData)? someData : '';
  },

  drawDataInContainer(dataToDisplay, currentFilmID) {

    this.cleanContainer();
    if(dataToDisplay)
      dataToDisplay.forEach((item, index) => htmlBody.insertAdjacentHTML('beforeend', this.getElement(item, index , currentFilmID)));
  },

  drawMarkupInContainer(markup) {
    htmlBody.insertAdjacentHTML('beforeend', markup);
  },

};
